import React from "react";
import Field from "./field";
const Checkbox = (props) => {
    const validationFunction = (value) => {
        return value.length > 0;
    };
    return (React.createElement(Field, { ...props, isGroup: true, multiple: true, type: props.type || "checkbox", defaultValue: props.choices
            .filter((e) => e.isSelected)
            .map((e) => e.value), defaultClassName: "checkbox-group", validationFunction: validationFunction }));
};
export default Checkbox;
